module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAYAAAC5UQwxAAAA6ElEQVR4AWJwL/ABFFsGNx/CIBRfxjk6Re/O0y1chhmYgQ1648MvHBrjP0Kx+JJ3ss0vvlAg1aZDzFzETQxiEnc1iUG/lRBQQVWMbBeKqwuooE0MPC8QbyagxkccF93FfAfr/J76FXqNkfh9kXi7AwKvE4xArUZTPId6JvY6AtF4YYwfnUD8B2qhPOrH8zmc0HJearNAhe6OiJsWyyTQHzGchykA9EZM56FuB4ahfQVwfwJS4h+SvWiMMEvRtLQq1WdREt9hGVvb6k6D3uYd7aXVPp7i0wLSB3DqipG6RKWuiV8swt+v+n/JWIkWRbVc+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/sign-detail-video-icon.png
// module id = TITJ
// module chunks = 215